var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import CreateTeamForm from '@/Pages/Teams/CreateTeamForm';
import AppLayout from '@/Layouts/AppLayout';
export default function Create() {
    return (_jsx(AppLayout, __assign({ title: "Create team", pageTitle: "Create a team" }, { children: _jsx("div", { children: _jsx("div", __assign({ className: "max-w-7xl mx-auto py-10 sm:px-6 lg:px-8" }, { children: _jsx(CreateTeamForm, {}) })) }) })));
}
